const upperCamelCaseRegex = /^[0-9A-Z][0-9A-Za-z:]+?$/;

export function createElementId (...path: string[]): string {
    if (!path.every((chunk: string): boolean => {
        return upperCamelCaseRegex.test(chunk);
    })) {
        throw new Error(`Element ID created using "${path.join(', ')}" which is non-standard. Each element in the path must be UpperCamelCase.`);
    }

    return path.join(':');
}
